import { render } from "./BaseTextarea.vue?vue&type=template&id=347262c0"
import script from "./BaseTextarea.vue?vue&type=script&lang=ts"
export * from "./BaseTextarea.vue?vue&type=script&lang=ts"

import "./BaseTextarea.vue?vue&type=style&index=0&id=347262c0&lang=scss"
script.render = render

export default script